module.exports = __webpack_public_path__ + "img/success-delivery.cb77ffdd.svg";